import Model from 'flarum/common/Model';

export default class AskQuestion extends Model {}

Object.assign(AskQuestion.prototype, {
  discussionId: Model.attribute('discussionId'),
  postId: Model.attribute('postId'),
  caseId: Model.attribute('caseId'),
  userId: Model.attribute('userId'),
  targetType: Model.attribute('targetType'),
  highlightedText: Model.attribute('highlightedText'),
  domAnchor: Model.attribute('domAnchor'),
  question: Model.attribute('question'),
  answer: Model.attribute('answer'),
  status: Model.attribute('status'),
  viewPrice: Model.attribute('viewPrice'),
  purchaseCount: Model.attribute('purchaseCount'),
  canCancel: Model.attribute('canCancel'),
  canEdit: Model.attribute('canEdit'),
  canViewAnswer: Model.attribute('canViewAnswer'),
  needPurchase: Model.attribute('needPurchase'),
  aiCost: Model.attribute('aiCost'),
  humanCost: Model.attribute('humanCost'),
  createdAt: Model.attribute('createdAt', Model.transformDate),

  // 划词提问列表所需字段
  needAi: Model.attribute('needAi'),
  needMentor: Model.attribute('needMentor'),
  aiAnswer: Model.attribute('aiAnswer'),
  aiAnsweredAt: Model.attribute('aiAnsweredAt', Model.transformDate),
  answeredAt: Model.attribute('answeredAt', Model.transformDate),
  answeredBy: Model.attribute('answeredBy'),

  user: Model.hasOne('user'),
  discussion: Model.hasOne('discussion'),
});
